"use client";

import { createContext } from "react";
import { API_FETCHER_CONTEXT_DEFAULT_VALUE } from "../../constants/contexts/defaultValues";

/**
 * @template T
 * @template [M=any]
 * @typedef {object} ApiFetcherContextValue
 * @prop {import("../../hooks/useApiFetcher").ApiFetcher} apiFetcher
 */

export const ApiFetcherContext = createContext(
  API_FETCHER_CONTEXT_DEFAULT_VALUE,
);
